module.exports = __webpack_public_path__ + "img/qrcode.0cc7058d.jpg";